import { render } from "./rollCallStudent.vue?vue&type=template&id=65aa8537"
import script from "./rollCallStudent.vue?vue&type=script&lang=js"
export * from "./rollCallStudent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__